import React from 'react';
import { UserRole } from '@99designs/apps/spa/pages/auth/SSO/common/types';
import { Heading, SmallSectionHeading } from '@99designs/emu';

export type MarketingOptInHeaderProps = {
    headingSize: 'small' | 'jumbo';
    userRole: UserRole;
};

export function MarketingOptInHeader({ headingSize, userRole }: MarketingOptInHeaderProps) {
    let heading = __("Want to know what's new? Let’s stay in touch!");

    if (userRole === 'designer') {
        heading = __('Want to receive designer content and updates from our community?');
    }

    if (headingSize === 'jumbo') {
        return (
            <Heading accessibilityLevel={1} appearanceLevel={2}>
                {heading}
            </Heading>
        );
    }

    return <SmallSectionHeading>{heading}</SmallSectionHeading>;
}
